export default __webpack_public_path__ + "static/media/logo.f7be7533.svg";